import { useEffect, useState } from 'react';

import { updateSessionStorage } from '../../utilities';

function useGlobalNav(navigationData) {
  const [navigationWithChildItems, setNavigationWithChildItems] = useState(null);
  const [tabHistory, setTabHistory] = useState(['main']);
  const [activeTabName, setActiveTabName] = useState(null);
  const [navItemForDisplay, setNavItemsForDisplay] = useState(navigationData);
  const getNavItemById = (arr, id) =>
    arr.reduce((result, current) => {
      if (result) {
        return result;
      }
      if (current.id === id) {
        return current;
      }
      if (current.items && tabHistory.includes(current.id)) {
        return getNavItemById(current.items, id);
      }
      return result;
    }, null);

  const handleChildNav = ({ id, link: { title } }) => {
    const updatedTabHistory = [...tabHistory, id];
    const { items } = getNavItemById(navigationWithChildItems, id);
    setActiveTabName(title);
    setTabHistory(updatedTabHistory);
    setNavItemsForDisplay(items);
  };

  const handleParentNav = () => {
    const previewsTab = tabHistory[tabHistory.length - 2];
    if (previewsTab === 'main') {
      setNavItemsForDisplay(navigationData);
      setTabHistory(['main']);
    } else {
      const {
        items,
        link: { title }
      } = getNavItemById(navigationWithChildItems, previewsTab);
      const updatedTabHistory = [...tabHistory].slice(0, tabHistory.length - 1);
      setActiveTabName(title);
      setTabHistory(updatedTabHistory);
      setNavItemsForDisplay(items);
    }
  };

  const setHostName = ({ link }) => {
    const path = updateSessionStorage.getItem('fibiPath');
    let updatedLink;
    if (link.href.includes('sustainability')) {
      let baseURL = path.split('/').filter(item => item);
      if (path.includes('food')) {
        baseURL = `/${baseURL[0]}/sustainability/${baseURL[1]}/${baseURL[2]}/${baseURL[3]}`;
      } else {
        baseURL = `${path}`;
      }
      updatedLink = {
        ...link,
        href: `${baseURL}${link.href}`
      };
    } else {
      updatedLink = { ...link, href: `${path}${link.href}` };
    }
    return updatedLink;
  };

  const groupNestedData = () => {
    const nestedGroups = (navigationData && navigationData.filter(data => data.items)) || [];
    setNavigationWithChildItems(nestedGroups);
  };

  useEffect(() => {
    setNavItemsForDisplay(navigationData);
    if (navigationData && navigationData.length) {
      groupNestedData();
    }
  }, [navigationData]);

  return { navItemForDisplay, tabHistory, handleParentNav, handleChildNav, activeTabName, setHostName };
}

export default useGlobalNav;
